import { atomWithStorage } from 'jotai/utils';
import { BACKPACK_ACTIVE_TAB_KEY } from '@/const/storage-key';

// 背包上次选中的 tab，持久化到 localStorage
export const backpackActiveTabAtom = atomWithStorage<string>(BACKPACK_ACTIVE_TAB_KEY, '');
